import React from 'react';
import PropTypes from 'prop-types';

import CardSlider from 'components/consumer/CardSlider';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import useStaticProductCardData from 'hooks/useStaticProductCardData';
import ProductCardStatic from '../ProductCardStatic';

const ProductCardCarousel = ({
  analyticsComponentName,
  className,
  ids,
  isAdmin,
  title = '',
}) => {
  const { products } = useStaticProductCardData({
    productIds: ids,
  });

  if (isAdmin) {
    return (
      <AdminPlaceholder>
        Product Card Carousel Placeholder for Variant Builder. The component
        will display correctly in Consumer
      </AdminPlaceholder>
    );
  }

  if (!Array.isArray(ids) || ids.length < 1) {
    return null;
  }

  const xcTag = title
    ? title
        .split(' ')
        .join('-')
        .toLowerCase()
    : '';

  return (
    <div className={className || 'px-0 py-8'} data-xc={xcTag}>
      {title && (
        <FixedWidthContainer wide>
          <div className="text-2xl font-bold text-gray mb-6">{title}</div>
        </FixedWidthContainer>
      )}

      <CardSlider>
        {products.map(product => (
          <ProductCardStatic
            analyticsComponentName={analyticsComponentName}
            key={product.slug}
            layout="minimal"
            {...product}
          />
        ))}
      </CardSlider>
    </div>
  );
};

ProductCardCarousel.propTypes = {
  analyticsComponentName: PropTypes.string,
  className: PropTypes.string,
  ids: PropTypes.arrayOf(PropTypes.number),
  idType: PropTypes.oneOf(['id', 'sku']),
  isAdmin: PropTypes.bool,
  title: PropTypes.string,
};
export default ProductCardCarousel;
